import Overview from './overview';

const Chart = {
  Overview,
};

export default Chart;
